export default __webpack_public_path__ + "static/media/sketch.fa6d7eb5.svg";